export const FF_PDP_LINK_CLICK_ON_ORDERS_HISTORY_GA_TRACKING = 'FF_PDP_LINK_CLICK_ON_ORDERS_HISTORY_GA_TRACKING';
export const FF_ORDER_HISTORY_INTERACTION_GA_EVENTS = 'FF_ORDER_HISTORY_INTERACTION_GA_EVENTS';
export const FF_PAYMENT_METHOD_CODE = 'FF_PAYMENT_METHOD_CODE';
